import React from "react";
import { Box, Container, Typography, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import FolderIcon from "@mui/icons-material/Folder";
import SchoolIcon from "@mui/icons-material/School";
import GavelIcon from "@mui/icons-material/Gavel";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import styles from "./Solutions.module.css";
import { useTranslation } from 'react-i18next';

const SolutionsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const handleCardClick = (path) => {
    navigate(path);
  };

  const cards = [
    {
      icon: <GavelIcon />,
      title: t('solutions.policies.title'),
      description: t('solutions.policies.description'),
      path: "/solutions/policies",
      color: "rgb(66, 165, 245)"
    },
    {
      icon: <FolderIcon />,
      title: t('solutions.operational.title'),
      description: t('solutions.operational.description'),
      path: "/solutions/operational",
      color: "rgb(255, 171, 64)"
    },
    {
      icon: <SchoolIcon />,
      title: t('solutions.pastExperiences.title'),
      description: t('solutions.pastExperiences.description'),
      path: "/solutions/past-experiences",
      color: "rgb(15, 232, 128)"
    },
  ];
  
  return (
    <Box className={styles.solutionContainer}>
      <Container maxWidth="lg" className={styles.mainContainer}>
        <Box className={styles.contentWrapper}>
          <Box className={styles.headerSection}>
            <Typography variant="h1" className={styles.pageTitle}>
              {t('solutions.pageTitle')}
            </Typography>
            <Typography variant="h2" className={styles.pageSubtitle}>
              {t('solutions.pageSubtitle')}
            </Typography>
          </Box>
          
          <Box className={styles.cardsSection}>
            {cards.map((card, index) => (
              <Box 
                key={index}
                className={styles.cardItem}
                onClick={() => handleCardClick(card.path)}
                sx={{
                  '--card-color': card.color,
                  '--card-delay': `${index * 0.1}s`,
                  cursor: 'pointer'
                }}
              >
                <Box className={styles.cardContent}>
                  <Box className={styles.cardMain}>
                    <Box className={styles.iconWrapper}>
                      <Box className={styles.iconBackground} />
                      <Box className={styles.iconContainer}>
                        {React.cloneElement(card.icon, { className: styles.cardIcon })}
                      </Box>
                    </Box>
                    <Box className={styles.textContent}>
                      <Typography className={styles.cardTitle}>
                        {card.title}
                      </Typography>
                      <Typography className={styles.cardDescription}>
                        {card.description}
                      </Typography>
                    </Box>
                  </Box>
                  <IconButton className={styles.arrowButton}>
                    <ArrowForwardIcon />
                  </IconButton>
                </Box>
                <Box className={styles.cardBackground} />
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default SolutionsPage;